import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import * as React from 'react';

const styles = {
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    alignItems: 'center',
    // position: 'absolute',
    // bottom: 0,
  },
};

const PagingPanelContainerBase = ({ classes, className, selectionType, selection, hideSelection, ...props }) => (
  <div className={clsx(classes.root, className)}>
    <div
      className={classes.pagingTextPanel}
      style={{ display: 'flex', marginRight: 'auto', padding: '12px', paddingLeft: '24px' }}
    >
      {!hideSelection && (
        <>
          <span style={{ paddingRight: '8px' }}>Total selecionados:</span>
          <span>{selectionType !== 'TODOS_FILTRO' ? selection.length : props.totalCount - selection.length}</span>
        </>
      )}
    </div>
    <PagingPanel.Container {...props} />
    <div style={{ visibility: 'hidden', marginLeft: 'auto', padding: '12px', paddingRight: '24px' }}>
      <span style={{ paddingRight: '8px' }}>Total selecionados:</span>
      <span>{selection.length}</span>
    </div>
  </div>
);

PagingPanelContainerBase.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  selection: PropTypes.array,
  selectionType: PropTypes.string,
  totalCount: PropTypes.number,
};

PagingPanelContainerBase.defaultProps = {
  className: undefined,
  totalCount: 0,
};

export const PagingPanelContainer = withStyles(styles)(PagingPanelContainerBase);
